import React from "react";
import { Link } from "wouter";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function UnsubscribedPage() {
  useDocumentTitle("Unsubscribed");

  return (
    <div className="container mx-auto max-w-md py-24 px-4 text-center">
      <div className="w-14 h-14 rounded-xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mx-auto mb-6">
        <CheckCircle className="w-7 h-7 text-emerald-400" />
      </div>
      <h1 className="text-2xl font-bold text-white mb-3">You have been unsubscribed</h1>
      <p className="text-zinc-400 font-sans text-sm mb-8">
        You have been successfully unsubscribed from all email alerts.
      </p>
      <Button
        asChild
        className="bg-primary hover:bg-primary/90 text-white font-bold uppercase text-sm tracking-wide"
      >
        <Link href="/">Back to Directory</Link>
      </Button>
    </div>
  );
}
